/** C 端智越视频 source，默认传 1 */
export const ZY_PLAY_SOURCE = "1";

export function getZyVideoId(info) {
  if (!info) {
    return "";
  }
  // play/resource 返回的 resource_id 即 course_resource.id
  return info.resource_id || info.zy_video_id || info.video_id || "";
}

export function isZhiyueVideo(info) {
  if (!info) {
    return false;
  }
  if (Number(info.zy_course_id) > 0) {
    return true;
  }
  return Number(info.yun_type) === 6 && !!(info.resource_id || info.zy_course_id);
}

export function getDefaultPlayUrl(info) {
  if (!info) {
    return "";
  }
  return info.original_link || info.video_url || info.play_url || "";
}

export function buildZyPlayParams({ courseId, sectionId, host, info }) {
  const params = {
    source: ZY_PLAY_SOURCE,
    host,
  };

  const videoId = getZyVideoId(info);
  if (videoId) {
    params.video_id = videoId;
  }

  const resolvedCourseId = (info && (info.zy_course_id || info.course_id)) || courseId;
  const resolvedSectionId = (info && info.zy_courseware_id) || sectionId;
  if (resolvedCourseId) {
    params.course_id = resolvedCourseId;
  }
  if (resolvedSectionId) {
    params.section_id = resolvedSectionId;
  }

  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "null") || {};
    const user = JSON.parse(localStorage.getItem("user") || "null") || {};
    if (user.id || userInfo.id) {
      params.user_id = user.id || userInfo.id;
    }
    if (userInfo.name || userInfo.nickname) {
      params.real_name = userInfo.name || userInfo.nickname;
    }
    if (userInfo.id_card) {
      params.cert_no = userInfo.id_card;
    }
  } catch (e) {
    // ignore parse errors
  }

  return params;
}

/**
 * 解析课程播放地址：智越视频走 /v1/course/play/zy/playUrl，否则用 original_link
 */
export function resolveCoursePlayUrl(axios, playInfo, options) {
  const info = (playInfo && playInfo.info) || playInfo || {};
  const defaultUrl = getDefaultPlayUrl(info);

  if (!isZhiyueVideo(info)) {
    return Promise.resolve(defaultUrl);
  }

  return axios
    .post(
      "/v1/course/play/zy/playUrl",
      buildZyPlayParams({
        courseId: options.courseId,
        sectionId: options.sectionId,
        host: options.host,
        info,
      }),
      { useLog: true }
    )
    .then((res) => {
      if (res.code == 0 && res.data && res.data.play_url) {
        return res.data.play_url;
      }
      if (defaultUrl) {
        return defaultUrl;
      }
      return Promise.reject(new Error(res.msg || "获取智越播放链接失败"));
    });
}
